import React from 'react'
import View from './view'

const DashboardHome = ({ ...props }) => <View {...props} />

export default DashboardHome
